/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import Helmet from 'react-helmet'
import PropTypes from "prop-types"


import Header from "../components/globals/header"
import Footer from "../components/globals/footer"

import './bootstrap.min.css';
import "./layout.css"



const Layout = ({ children }) => (
  <>
    <Helmet>
      
   <meta name="google-site-verification" content="mv7HWza9Ce6ZBFFMj5aKV-vlhVCB4UMN2fY0LCsiscU" />
   
    </Helmet>
    <Header />

    { children }
  <Footer />
  </>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
